import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { cn } from "@volca/ui/lib/utils";
import { useGetMyUser } from "@/user/query";
import { isAdminOrOwnerOrManager } from "@/user/utils";

interface PayReferralButtonProps {
  onPay: () => void;
  className?: string;
}

export const PayReferralButton = ({
  onPay,
  className,
}: PayReferralButtonProps) => {
  const { data: userInfo } = useGetMyUser();
  const canPayout = isAdminOrOwnerOrManager(userInfo?.role);

  const button = (
    <Button
      variant="outline"
      size="sm"
      disabled={!canPayout}
      className={cn({ "w-full": !canPayout }, className)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (canPayout) onPay();
      }}
    >
      Pay
    </Button>
  );

  if (canPayout) return button;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          // A disabled button can't take focus, so its wrapper does.
          <span
            tabIndex={0}
            className={cn(
              "inline-flex rounded-lg outline-none focus-visible:ring-3 focus-visible:ring-focus/50",
              className,
            )}
          />
        }
      >
        {button}
      </TooltipTrigger>
      <TooltipContent>
        Only managers, legacy managers, and admins can pay advocates for
        referrals.
      </TooltipContent>
    </Tooltip>
  );
};
